module.exports = __webpack_public_path__ + "static/icons/icon-9-day-186d971ec5037d5956a9059340510473.svg";